module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAArCAMAAAAJzfvtAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRF29zcytfQ5+fo2uvkydHM0Obc+vv79PT07fLvz97X9Pj21ePc1ejf0dHR////3u7pHNehswAAAQJJREFUeNq01UuuwyAMBVA+CZ8Em/3v9lGnSStiHKzq3UE74chcQIpZxRTsY6oUv90BlvH6cl+PxuQxyMYxYPFjAAwIYMdiZ7aERhCFAw7ADk8pMaCNgGFxHxjQxLj47SYM/Qgn1QsCQQD9rgigy9IDYUCEXXgggQN2dsQBggh8DT3AJE6oZU0dQLH197ZOUOTln+In8DLImxKsTrml6nuwP4GkBNW/39Q0OIkCHJehAl4LinrCpu3QautAqz39Ws8WSrD+D6Bv0VE6XyDZI7nFXlko8AqdioULRHgIbWH5AWzcIkNxFPsqAp+Le0z7KMDicB7QyDgPghZgjK1I+/8TYABvIW0/hQN2uAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/MO.png
// module id = QPNn
// module chunks = 1